/** @jsx jsx */
import { Link as GatsbyLink } from 'gatsby'
import { jsx } from 'theme-ui'
import PropTypes from 'prop-types'

const ScrollToLink = ({ data, id }) => {
  const { text, htmlId } = data.fields
  return (
    <GatsbyLink
      id={id}
      to={`#${htmlId}`}
      sx={{
        fontSize: 3,
        cursor: 'pointer',
        fontFamily: 'heading',
        fontWeight: 'normal',
        color: 'primary',
        lineHeight: 'heading',
        textDecoration: 'underline',
        textDecorationColor: 'lightBlue',
      }}
    >
      {text}
    </GatsbyLink>
  )
}

ScrollToLink.propTypes = {
  data: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
}

export default ScrollToLink
